(function () {
    'use strict';
    $(document).ready(function () {

        //Smmoth scroll to
        $('body').on('click', '.scroll-animation',function (e) {
            e.preventDefault();

            const href = $(this).attr('href');
            if (href) {
                $("html, body").animate({
                    scrollTop: $(href).offset().top
                }, 1000);
            }
        });

        $('.scroll-animation a').on('click', function (e) {
            e.stopPropagation();
        });

        //Just Reveal animations
        const controller = new ScrollMagic.Controller();
        const JRElements = $('.just-reveal');
        const totalJRElements = JRElements.length;

        JRElements.each(function (index) {
            const $this = $(this);
            const target = $this[0];

            let triggerHook = 0.75; // default one for all elements

            // if (index === totalJRElements - 1) // for last animation element
            //     triggerHook = .95;

            if ((index === totalJRElements - 1) ||
                (index === totalJRElements - 2) ||
                (index === totalJRElements - 3)) { // for 3 last animation element
                triggerHook = 1;
            }

            new ScrollMagic.Scene({
                triggerElement: target,
                triggerHook: triggerHook
            })
            .on('enter', function () {
                target.classList.add('jr-running');
                // if ($(target).find('.jr-count:not(.jr-running)').length)
                //     countFromZero($(target).find('.jr-count:not(.jr-running)'));
            })
            .addTo(controller);
        });

        //Menu mobile toggle

        $(".menu-toggle").on('click', function(){
            $('.menu-overlay').fadeToggle();
            $(this).toggleClass("open");
            $('.header').toggleClass("open");
        });

        $('.menu-overlay').mCustomScrollbar({
            axis: "y",
            mouseWheel: {
                enable: true
            }
        });

        //Linki posiadające podmenu - wyłączenie domyślnego zachowania

        $("#site-menu-desktop li.menu-item-has-children > a").on('click', function (e) {
            e.preventDefault();
        });

        $("#site-menu-desktop li.menu-item-has-children > ul," +
            "#site-menu li.menu-item-has-children > ul > li").on('click', function (e) {
            e.stopPropagation();
        });

        //Mainmenu - level 1

        $("#site-menu-desktop > li.menu-item-has-children > ul li.menu-item-has-children").click(function () {
            $(this).children('ul').slideToggle({
                start: function () {
                    $(this).css({
                        display: "flex"
                    })
                }
            });
            $(this).toggleClass('open');

            $(this).siblings('li').children('ul').slideUp();
            $(this).siblings('li').removeClass('open');

            $(this).parent().parent().siblings('li').find('ul li ul').slideUp();
            $(this).parent().parent().siblings('li').find('ul li').removeClass('open');
        });

        //Search trigger

        $('.search-trigger').on('click', function () {
            $(this).toggleClass('active');
            $('.search-panel').fadeToggle('active');
            return false;
        });

    });
}(jQuery));
